// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"283":"astrologer","411":"kundali","528":"reports","795":"panchang","884":"admin"}[chunkId] + "." + {"283":"7a4f3334","411":"33d471a4","528":"6b338500","795":"7a4f3334","884":"d6590425"}[chunkId] + ".chunk.css";
};